import type { JSX } from 'react'

export const TwitterSolidIcon = (): JSX.Element => (
  <use href='#twitterSolidIcon' height='100%' width='100%' />
)
